import type { FunctionComponent, ReactNode } from 'react';

import type { InsightCategoryT, InsightT } from 'utils';

import { Insight } from '../../Insight';

import './style.scss';

type PropsT = {
  insights: InsightT[];
};

export const RightPanel: FunctionComponent<PropsT> = ({
  insights,
}) => {
  const iGroups: Partial<Record<InsightCategoryT, string[]>> = {};
  for (const insight of insights) {
    let group = iGroups[insight.category];
    if (!group) {
      group = [];
      iGroups[insight.category] = group;
    }

    // `insights` may include duplicates.
    if (!group.includes(insight.insight)) group.push(insight.insight);
  }

  const iGroupArray = Object.entries(iGroups)
    .sort((a, b) => a[0].localeCompare(b[0]));

  const items: ReactNode[] = [];
  for (const g of iGroupArray) {
    const group = g[0] as InsightCategoryT;
    for (const item of g[1]) {
      items.push(
        <Insight
          category={group}
          key={`item/${item}`}
        >
          {item}
        </Insight>,
      );
    }
  }

  const iNodes: ReactNode = items.length
    ? <div styleName="insightItems">{items}</div>
    : (
      <div styleName="emptyPlaceholder">
        Insights will appear here as we talk...
      </div>
    );

  return (
    <div styleName="container">
      <h3 styleName="title">Captured insights</h3>
      {iNodes}
    </div>
  );
};
